import R from 'ramda'

const SEND_REPLY_ACTION_TYPE = 'SEND_REPLY'
const SEND_REPLY_DISPLAY_TYPE = 'Send reply'

const isSendReplyWidgetAction = R.propEq('type', SEND_REPLY_ACTION_TYPE)

const convertSendReplyWidgetActionToFormAction = R.applySpec({
  type: R.always(SEND_REPLY_DISPLAY_TYPE),
  action: R.always(SEND_REPLY_ACTION_TYPE),
  message: R.prop('message'),
  attachmentUrl: R.prop('attachmentUrl'),
  cardUri: R.prop('cardUri'),
  media: R.prop('media'),
  hasMissedPostRedirect: R.prop('hasMissedPostRedirect'),
  missedPostRedirect: R.prop('missedPostRedirect'),
  isPromotedTweet: R.F
})

export { isSendReplyWidgetAction, convertSendReplyWidgetActionToFormAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/widget-to-form/send-reply.js